import React, { useEffect } from 'react'
import Navbar from './Navbar'
import '../assets/creercompte.css'

function CreationCompte() {
  useEffect(()=>{
    
    let header = document.querySelector('#menu');
    let burger = document.querySelector('.navbar-toggler');
    header?.classList.add('bg-navbar');

    if (window.screen.width < 985) {
      header?.classList.remove('scrolled');
      header?.classList.remove('bg-navbar');
      header?.classList.add('menuPanierOuProduit');
      burger?.classList.add("menuburger");
    }
  }, [])

  return (
    <div>
      <Navbar />
      <div id="createAccount" className='container mt-5 text-center col-md-4 col-sm-6'>
        <h1 className='text-uppercase'>Créer un compte</h1>
        <form action="" className='mt-5'>
          <div className="form-group mb-2">
            <input type="text" placeholder='Nom' className='form-control' />
          </div>
          <div className="form-group mb-2">
            <input type="text" placeholder='Prenom' className='form-control' />
          </div>
          <div className="form-group mb-2">
            <input type="email" placeholder='Adresse mail' className='form-control' />
          </div>
          <div className="form-group mb-2">
            <input type="password" placeholder='Mot de passe' className='form-control mt-3' />
          </div>

          <button type='submit' className='btn btn-dark form-control mt-5 text-white' id='btn-validate'>Créer mon compte</button>
        </form>
      </div>
    </div>
  )
}

export default CreationCompte